import React from 'react';
import MessageDefinitions from '../i18n/MessageDefinitions';
import {FormattedMessage, intlShape} from 'react-intl';
import FontAwesome from 'react-fontawesome';
import SpinnerQuestion from './questionTypes/SpinnerQuestion';
import DropdownQuestion from './questionTypes/DropdownQuestion';
import RadioQuestion from './questionTypes/RadioQuestion';
import CheckboxQuestion from './questionTypes/CheckboxQuestion';
import {BuildSelectOptions} from '../util/BuildOptions';

const questionComponents = {
  spinner: SpinnerQuestion,
  dropdown: DropdownQuestion,
  radio: RadioQuestion,
  checkbox: CheckboxQuestion
};

const QuestionRowSelector =
  ({
     availableRows = [],
     onChange,
     onRemove,
     disableRemove = false
   }) => {
    const goalOptions = BuildSelectOptions(availableRows);

    const typeChanged = (event) => {
      onChange(event.target.value);
    };

    const removeButton = !disableRemove ? <button className="btn btn-link remove" onClick={onRemove}><FontAwesome name="trash-o"/></button> : null;

    return <div className="question-row">
      <div className="question-cell">
        <label>
          <FormattedMessage {...MessageDefinitions.prompt} />
        </label>
        <select className="form-control" onChange={typeChanged} value="">
          <option value="">Please select</option>
          {goalOptions}
        </select>
      </div>
      {removeButton}
    </div>;
  };

//TODO: Enhanced validation
const ActiveQuestionRow =
  ({
     questionRow,
     onChange,
     onRemove,
     onChecked,
     checked = false,
     showAllMode = false,
     isToggle = false,
   }) => {
    const {
      key: rowKey,
      value: rowValue,
      questions = []
    } = questionRow;

    const renderedQuestions = (!showAllMode && !isToggle) || (showAllMode && checked) ?
      questions.filter(question => question.type).map((question, index) => {
        const { key, value, type, answer, attributes={} } = question;
        const answers = question.answers ? question.answers : [];
        const Component = questionComponents[type];

        return <div className="question-cell" key={key}>
          <label>{value}</label>
          <Component
            rowKey={rowKey}
            questionKey={key}
            answers={answers}
            attributes={attributes}
            valueChanged={onChange}
            answer={answer}
          />
        </div>;
      })
      : null;

    const checkBoxClicked = (e) => {
      const box = document.getElementById(e.target.id);
      onChecked(box.checked);
    };

    const questionRowCheckbox = showAllMode ? <input className="custom-control-input checkbox" type="checkbox" id={rowKey} onChange={checkBoxClicked} checked={checked} /> : null;

    const removeButton = showAllMode ? null : <button className="btn btn-link remove" onClick={onRemove}><FontAwesome name="trash-o"/></button>;

    return <div className={`question-row ${rowKey}`}>
      <div className="question-cell row-key">
        <label>
          {questionRowCheckbox}
          <FormattedMessage {...MessageDefinitions.prompt} />
        </label>
        <div className="form-control form-control-plaintext">{rowValue}</div>
      </div>
      {renderedQuestions}
      {removeButton}
    </div>;
  };

export {
  QuestionRowSelector,
  ActiveQuestionRow
};



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/components/QuestionRow.js
 **/